import styled from 'styled-components';
import { breakpoints } from '../../../styles/theme';
import { CheckoutDeliveryStyled } from '../CheckoutDeliveryStyled';
import { rem } from 'polished';

export const CheckoutDeliveryStyledAC = styled(CheckoutDeliveryStyled)`
    .dealerSearch {
        height: fit-content;
        display: flex;
        flex-direction: column;
        @media (min-width: ${breakpoints.xs}px) {
            flex-direction: row;
            align-items: center;
        }
        input {
            width: 100%;
            color: ${({ theme }) => theme.colors.grey1};
            font-size: ${({ theme }) => theme.fontSizes.textBase};
            line-height: ${({ theme }) => theme.lineHeights.textSupMedium};
            border: ${rem('1px')} solid ${({ theme }) => theme.colors.grey3};
        }
        button {
            width: 100%;
            font-size: ${rem(14)};
            border: 1px solid ${({ theme }) => theme.colors.grey3};
            text-transform: uppercase;
            padding: ${rem(10)} ${rem(15)};
            margin: ${rem(16)} 0;
            @media (min-width: ${breakpoints.xs}px) {
                flex: 1;
                margin-left: ${rem(16)};
            }
        }

        &__input {
            ::before {
                width: ${rem(32)};
                height: ${rem(32)};
                left: 0;
            }
            @media (min-width: ${breakpoints.xs}px) {
                flex: 4;
            }
        }
    }

    .dealerItem {
        &__button {
            width: ${rem(125)};
            padding: ${rem(5)};
            border: ${rem(4)} solid ${({ theme }) => theme.colors.primary};
            font-size: ${rem(14)};
            font-family: ${({ theme }) => theme.fonts.fontBase};
            font-weight: bold;
            color: ${({ theme }) => theme.colors.primary};

            &:hover {
                color: ${({ theme }) => theme.colors.white};
            }
        }

        &__icon {
            background: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMjIiIHZpZXdCb3g9IjAgMCAxNCAyMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTcgMEMzLjEzMzU5IDAgMCAzLjEyNDQgMCA2Ljk3OTQ3QzAgMTEuNzM0MiA1LjM2NDg0IDEzLjQ2ODIgNi41MzI0MiAyMC44MzQ4QzYuNjA4OTggMjEuMzA5MiA2LjYxNDQ1IDIxLjYzNjQgNyAyMS42MzY0QzcuMzg1NTUgMjEuNjM2NCA3LjM5MTAyIDIxLjMwOTIgNy40Njc1OCAyMC44MzQ4QzguNjM1MTYgMTMuNDY4MiAxNCAxMS43MzQyIDE0IDYuOTc5NDdDMTQgMy4xMjQ0IDEwLjg2NjQgMCA3IDBaIiBmaWxsPSIjRDczRjM1Ii8+Cjwvc3ZnPg==')
                top center no-repeat;
        }

        &__footer {
            .btnSelected {
                background-color: ${({ theme }) => theme.colors.primary};
                color: ${({ theme }) => theme.colors.white};
            }
        }
    }

    .selectedDealer {
        &__header {
            span:first-child {
                background-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI0IDEyQzI0IDE4LjYyNzQgMTguNjI3NCAyNCAxMiAyNEM1LjM3MjU2IDI0IDAgMTguNjI3NCAwIDEyQzAgNS4zNzI1NiA1LjM3MjU2IDAgMTIgMEMxOC42Mjc0IDAgMjQgNS4zNzI1NiAyNCAxMloiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTIgMjRDMTguNjI3NCAyNCAyNCAxOC42Mjc0IDI0IDEyQzI0IDUuMzcyNTYgMTguNjI3NCAwIDEyIDBDNS4zNzI1NiAwIDAgNS4zNzI1NiAwIDEyQzAgMTguNjI3NCA1LjM3MjU2IDI0IDEyIDI0Wk0xOS41MTUyIDkuNDUwNjhMMTAuNjEyIDE4LjM1MzlDMTAuMzA5NiAxOC42NTYyIDkuODE5NDQgMTguNjU2MiA5LjUxNzA3IDE4LjM1MzlMNC40ODQ4MSAxMy4zMjE2QzQuMTgyNDggMTMuMDE5MyA0LjE4MjQ4IDEyLjUyOTEgNC40ODQ4MSAxMi4yMjY3TDUuNTc5NjYgMTEuMTMxOUM1Ljg4MjAzIDEwLjgyOTYgNi4zNzIyNCAxMC44Mjk2IDYuNjc0NTYgMTEuMTMxOUwxMC4wNjQ1IDE0LjUyMThMMTcuMzI1NCA3LjI2MDk3QzE3LjYyNzggNi45NTg2IDE4LjExOCA2Ljk1ODYgMTguNDIwMyA3LjI2MDk3TDE5LjUxNTIgOC4zNTU4MkMxOS44MTc1IDguNjU4MTQgMTkuODE3NSA5LjE0ODM1IDE5LjUxNTIgOS40NTA2OFoiIGZpbGw9IiNFQjY0MjgiLz4KPC9zdmc+Cgo=');
            }
        }
    }

    .dealerSearch {
        &__input {
            ::before {
                background-image: url("data:image/svg+xml,%3Csvg width='49' height='44' viewBox='0 0 49 44' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M22.5 27C18.364 27 15 23.635 15 19.5C15 15.364 18.364 12 22.5 12C26.635 12 30 15.364 30 19.5C30 23.635 26.635 27 22.5 27ZM36.743 32.536L29.083 24.875C30.28 23.411 31 21.54 31 19.5C31 14.805 27.194 11 22.5 11C17.805 11 14 14.805 14 19.5C14 24.194 17.805 28 22.5 28C24.794 28 26.873 27.086 28.402 25.609L36.036 33.243C36.133 33.34 36.261 33.389 36.389 33.389C36.517 33.389 36.645 33.34 36.743 33.243C36.938 33.047 36.938 32.731 36.743 32.536Z' fill='%23142032'/%3E%3Cmask id='mask0' mask-type='alpha' maskUnits='userSpaceOnUse' x='14' y='11' width='23' height='23'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M22.5 27C18.364 27 15 23.635 15 19.5C15 15.364 18.364 12 22.5 12C26.635 12 30 15.364 30 19.5C30 23.635 26.635 27 22.5 27ZM36.743 32.536L29.083 24.875C30.28 23.411 31 21.54 31 19.5C31 14.805 27.194 11 22.5 11C17.805 11 14 14.805 14 19.5C14 24.194 17.805 28 22.5 28C24.794 28 26.873 27.086 28.402 25.609L36.036 33.243C36.133 33.34 36.261 33.389 36.389 33.389C36.517 33.389 36.645 33.34 36.743 33.243C36.938 33.047 36.938 32.731 36.743 32.536Z' fill='white'/%3E%3C/mask%3E%3Cg mask='url(%23mask0)'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M0 -3H50V47H0V-3Z' fill='%23796F6E'/%3E%3C/g%3E%3C/svg%3E%0A");
            }
        }
    }
`;
